var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "previous-page" }, [
    _vm.$route.query.isApp != 1
      ? _c("div", { staticClass: "previous-header" }, [
          _c("i", {
            staticClass: "iconfont icon-left",
            class: { mirrorRotateLevel: _vm.isDirection },
            on: {
              click: function($event) {
                return _vm.$router.go(-1)
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "previous-body" },
      [
        _c("p", { staticClass: "previous-title bold" }, [
          _vm._v(_vm._s(_vm.$t("300335")))
        ]),
        _vm._v(" "),
        _vm.takeNotes.length > 0
          ? _c(
              "van-list",
              {
                attrs: {
                  offset: "50",
                  finished: _vm.finished,
                  "loading-text": " ",
                  "finished-text": " "
                },
                on: { load: _vm.onLoad },
                model: {
                  value: _vm.loading,
                  callback: function($$v) {
                    _vm.loading = $$v
                  },
                  expression: "loading"
                }
              },
              _vm._l(_vm.takeNotes, function(item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "previous-item" },
                  [
                    _c("p", { staticClass: "Number-of-periods" }, [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(_vm.$t("300343", { num: item.roundCount }))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "Snap-purchase-user" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("300340")))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.nickname))])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "buyCount" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("300323")))]),
                      _vm._v(" "),
                      _c("span", [
                        _c("em", [_vm._v(_vm._s(item.buyCount) + " ")]),
                        _vm._v(_vm._s(_vm.$t("300306")) + "\n          ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "announceTime" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("300341")))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.parseTime(item.createTime)))
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          : _c(
              "div",
              { staticClass: "previous-nodata" },
              [
                _c("van-empty", { attrs: { description: _vm.$t("300108") } }, [
                  _c(
                    "svg",
                    {
                      staticClass: "icon empty-icon",
                      attrs: { slot: "image", "aria-hidden": "true" },
                      slot: "image"
                    },
                    [_c("use", { attrs: { "xlink:href": "#icon-jilu1" } })]
                  )
                ])
              ],
              1
            )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-487ab444", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-487ab444","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/purchase/previousRecords.vue
// module id = 7TCY
// module chunks = 0